export default __webpack_public_path__ + "static/media/uber-logo.36784ad9.webp";